/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Note {
    export interface INote {
        id: string;
        entityId: string;
        noteText: string;
        isAppointmentBooked?: boolean;
        isCheckIn?: boolean;
        isCheckOut?: boolean;
        displayPopupNotesAcrossLocations?: boolean;
        locationId?: number;
        locationName?: string;
        clientGlobalId?: string;
        clientType?: Model.ClientTypeEnum;
        clientGlobalIds?: string[];
        clientNames?: string[];
        displayName?: string;
        isAppointmentType: boolean;
        isRegisterType: boolean;
        isAppointmentNote?: boolean;
        isClientNote?: boolean;
        isMembershipNote?: boolean;
        isServiceNote?: boolean;
        appointmentId?: string;
        membershipId?: string;
        membershipName?: string;
        serviceId?: string;
        serviceShortcut?: string;
        serviceName?: string;
        isNewNote: boolean;
        isGroupedNote: boolean;
        entityVersion?: number;
        originalNote: Meevo.Model.ClientNote;
        isTenantOrOwnedServiceNote?: boolean;
    }

    export interface INoteBase {
        entityId: string;
    }

    export interface INoteAppointment extends INoteBase {
        appointmentId: string;
    }

    export interface INoteClient extends INoteBase {
        clientId: string;
        clientType: Model.ClientTypeEnum;
        clientDisplayName: string;
    }

    export interface INoteService extends INoteBase {
        serviceId: string;
    }

    export class NoteService {
        static $inject = [
            "meevo.components.common.DataService",
            "meevo.components.tracking.TrackingService",
            "meevo.components.modal.ModalService",
            "$q"
        ];

        // these must match the C# class implementation
        public AppointmentNoteAggregator = 'AppointmentNoteSourceLogic';
        public ClientNoteAggregator = 'ClientNoteSourceLogic';
        public MembershipNoteAggregator = 'MembershipNoteSourceLogic';
        public ServiceNoteAggregator = 'ServiceNoteSourceLogic';

        constructor(
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $q: ng.IQService
        ) {
        }

        formatNoteSourceItem(noteSourceItem: Meevo.Model.NoteSourceItem): INote {
            return {
                id: noteSourceItem.noteId,
                entityId: noteSourceItem.entityId,
                noteText: noteSourceItem.note,
                isAppointmentBooked: noteSourceItem.isAppointmentBooked,
                isCheckIn: noteSourceItem.isCheckIn,
                locationId: noteSourceItem.locationId,
                locationName: noteSourceItem.locationName,
                isCheckOut: noteSourceItem.isCheckOut,
                isAppointmentType: noteSourceItem.isAppointmentType,
                isRegisterType: noteSourceItem.isRegisterType,
                isNewNote: true,
                isGroupedNote: false,
                entityVersion: noteSourceItem.noteEntityVersion,
                originalNote: noteSourceItem,
                isTenantOrOwnedServiceNote: noteSourceItem.isTenantOrOwnedServiceNote,
            };
        }

        loadAggregatedNotes(
            noteAppointments: INoteAppointment[],
            noteClients: INoteClient[],
            noteServices: INoteService[],
            noteViewTime?: Meevo.Model.ClientNoteViewTimeEnum
        ): ng.IPromise<any> {
            const aggregatedNoteRequest = {
                appointmentIds: _(noteAppointments).pluck('appointmentId'),
                clientIds: _(noteClients).pluck('clientId'),
                serviceIds: _(noteServices).pluck('serviceId'),
                noteViewTime: noteViewTime,
            };

            return this.dataService.customMethodData('/api/notes/list', 'POST', aggregatedNoteRequest);
        }

        parseAggregatedNotes(noteSources, note: INoteBase): INote[] {
            const aggregatedNotes: INote[] = [];

            if (!noteSources || !note) {
                return aggregatedNotes;
            }

            for (const key in noteSources) {
                const noteSource = noteSources[key];

                const response = noteSource.find(aggregatedNote =>
                    aggregatedNote.requestEntityId === note.entityId &&
                    aggregatedNote.noteSourceItems.length > 0
                );

                if (!response) {
                    continue;
                }

                for (const noteSourceItem of response.noteSourceItems) {
                    let formattedNote = this.formatNoteSourceItem(noteSourceItem);
                    formattedNote.clientGlobalId = note['clientId'];
                    formattedNote.displayName = note['clientDisplayName'];

                    switch (key) {
                        case this.ClientNoteAggregator:
                            formattedNote.isClientNote = true;
                            break;

                        case this.MembershipNoteAggregator:
                            formattedNote.isMembershipNote = true;
                            formattedNote.entityId = noteSourceItem.entityId;
                            formattedNote.membershipId = noteSourceItem.entityId;
                            formattedNote.membershipName = noteSourceItem.entityName;
                            break;

                        case this.ServiceNoteAggregator:
                            formattedNote.isServiceNote = true;
                            formattedNote.entityId = noteSourceItem.entityId;
                            formattedNote.serviceId = noteSourceItem.entityId;
                            formattedNote.serviceName = noteSourceItem.entityName;
                            break;
                    }

                    aggregatedNotes.push(formattedNote);
                }
            }

            return aggregatedNotes;
        }

        showNotes(notes: INote[]) {
            if (notes.length === 0) {
                return this.$q.resolve(true);
            }

            let displayNames = _.chain(notes).pluck('displayName').filter(displayName => displayName).uniq().value()
            let noteClientDisplayName = '';

            if (displayNames.length == 1) {
                noteClientDisplayName = displayNames[0];
                _(notes).each(note => { note.displayName = '' });
            }

            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/modal/modal.template.html",
                controller: "meevo.components.modal.ModalController",
                locals: {
                    notes: notes,
                    isRegister: true,
                    noteClientDisplayName: noteClientDisplayName
                }
            };

            return this.modalService.noteRegister(modalOptions, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
        }

        usageTrackingLog(nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum): void {
            var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, null, null);
            this.trackingService.saveTrackingInfo(trackingItem);
        }
    }

    angular.module("meevo.plugins.note")
        .service("meevo.plugins.note.NoteService", NoteService);
}
